{
  "header": {
    "name": "Nom"
  },
  "empty": "Aucun secteur n'a été trouvé",
  "button": {
    "new": "Nouveau secteur",
    "newSub": "Ajouter un sous-secteur",
    "update": "Modifier le secteur",
    "remove": "Supprimer le secteur"
  },
  "label": "secteur",
  "validation": {
    "required": "Le champ doit être renseigné",
    "maxLength": "Longueur max. : {maxLength}",
    "nameFormat": "Le nom doit comporter seulement les caractères suivant [a-zA-Z0-9 _.-]",
    "minLength": "Longueur min. : {minLength}"
  },
  "details": {
    "tab": {
      "device": {
        "label": "Postes locaux S4"
      },
      "application": {
        "label": "Applicatifs"
      },
      "user": {
        "label": "Utilisateurs"
      },
      "userGroup": {
        "label": "Groupes d'utilisateurs"
      },
      "dtwins": {
        "label": "Équipements"
      },
      "sectors": {
        "label": "Secteurs"
      }
    },
    "buttons": {
      "create": "Nouveau secteur",
      "createSubSector": "Ajouter un sous-secteur",
      "remove": "Supprimer le secteur",
      "attach": {
        "application": "Attacher un applicatif",
        "device": "Attacher un équipement",
        "user": "Attacher un utilisateur",
        "userGroup": "Attacher un groupe d'utilisateurs",
        "dtwins": "Attacher un équipement"
      },
      "detach": "Retirer du secteur",
      "details": "Détails"
    },
    "currentSelection": "Selection courante"
  },
  "modals": {
    "create": {
      "title": "Créer un nouveau secteur",
      "sector": {
        "label": "Nom du secteur",
        "description": "Description"
      }
    },
    "update": {
      "title": "Mettre à jour un secteur",
      "sector": {
        "label": "Nom du secteur",
        "description": "Description"
      }
    },
    "remove": {
      "title": "Suppression du secteur {sectorName}",
      "description": "Êtes-vous sûr de vouloir supprimer ce secteur ?",
      "notAllowed": "La suppression d’un secteur n’est pas possible, des équipements y sont rattachés",
      "titleAlt": "Supprimer le secteur"
    },
    "confirmDetach": {
      "device": {
        "title": "Détachement de l'équipement d'un secteur",
        "description": "L'équipement \"{name}\" va être détaché du secteur \"{sectorLabel}\" | Les équipements suivants vont être détachés du secteur \"{sectorLabel}\"",
        "warning": "L'équipement détaché de tout secteur n'apparaitra plus sur les écrans de gestion (selon les droits utilisateurs). | Les équipements détachés de tout secteur n'apparaitront plus sur les écrans de gestion (selon les droits utilisateurs)."
      },
      "application": {
        "title": "Détachement de l'applicatif d'un secteur",
        "description": "L'applicatif \"{name}\" va être détaché du secteur \"{sectorLabel}\" | Les applicatifs suivants vont être détachés du secteur \"{sectorLabel}\"",
        "warning": "L'applicatif détaché de tout secteur n'apparaitra plus sur les écrans de gestion (selon les droits utilisateurs). | Les applicatifs détachés de tout secteur n'apparaitront plus sur les écrans de gestion (selon les droits utilisateurs)."
      },
      "user": {
        "title": "Détachement d'un utilisateur d'un secteur",
        "description": "L'utilisateur \"{name}\" va être détaché du secteur \"{sectorLabel}\" | Les utilisateurs suivants vont être détachés du secteur \"{sectorLabel}\"",
        "warning": "L'utilisateur détaché de tout secteur ne pourra plus accéder à la visualisation et à la gestion des équipements / applicatifs. | Les utilisateurs détachés de tout secteur ne pourront plus accéder à la visualisation et à la gestion des équipements / applicatifs."
      },
      "userGroup": {
        "title": "Détachement d'un groupe d'utilisateurs d'un secteur",
        "description": "Le groupe d'utilisateurs \"{name}\" va être détaché du secteur \"{sectorLabel}\" | Les groupes d'utilisateurs suivants vont être détachés du secteur \"{sectorLabel}\"",
        "warning": "Le groupe d'utilisateurs détaché de tout secteur ne pourra plus accéder à la visualisation et à la gestion des équipements / applicatifs. | Les groupes d'utilisateurs détachés de tout secteur ne pourront plus accéder à la visualisation et à la gestion des équipements / applicatifs."
      },
      "errors": {
        "list_empty": "Vous devez sélectionner au moins un élément à détacher"
      },
      "dtwins": {
        "title": "Détachement de l'équipement d'un secteur",
        "description": "L'équipement \"{name}\" va être détaché du secteur \"{sectorLabel}\" | Les équipements suivants vont être détachés du secteur \"{sectorLabel}\"",
        "warning": "L'équipement détaché de tout secteur n'apparaitra plus sur les écrans de gestion (selon les droits utilisateurs). | Les équipements détachés de tout secteur n'apparaitront plus sur les écrans de gestion (selon les droits utilisateurs)."
      }
    },
    "attach": {
      "device": {
        "title": "Rattacher des équipements à un secteur",
        "description": "Cocher les équipements à rattacher au secteur"
      },
      "application": {
        "title": "Rattacher des applicatifs à un secteur",
        "description": "Cocher les applicatifs à rattacher au secteur"
      },
      "user": {
        "title": "Rattacher des utilisateurs à un secteur",
        "description": "Cocher les utilisateurs à rattacher au secteur"
      },
      "userGroup": {
        "title": "Rattacher des groupes d'utilisateurs à un secteur",
        "description": "Cocher les groupes d'utilisateurs à rattacher au secteur"
      },
      "errors": {
        "list_empty": "Vous devez sélectionner au moins un élément à attacher"
      },
      "dtwins": {
        "description": "Cocher les équipements à rattacher au secteur",
        "title": "Rattacher des équipements à un secteur"
      }
    },
    "view": {
      "title": "Voir un secteur"
    }
  },
  "search": "Recherche par nom",
  "select": {
    "all": "Sélectionner tous les secteurs",
    "selected": "secteurs sélectionnés"
  },
  "treeview": {
    "actionsButton": {
      "title": "Actions"
    }
  },
  "selectedUsers": "Aucun utilisateur sélectionné | {count} utilisateur sélectionné | {count} utilisateurs sélectionnés",
  "selectedUserGroups": "Aucun groupe sélectionné | {count} groupe sélectionné | {count} groupes sélectionnés"
}
